import styleConverter from './cssConverter';
import StateManager from '../state_manager';
var tab = `  `;
function getStudioHtml() {
  var ht = editor.getHtml();
  var $ht = $(`<div>${ht}</div>`);
  var $divWithId = $ht.find('[id]');
  var idReplaced = [];
  $divWithId.each(function(i, e) {
    var id = $(e).attr('id');
    idReplaced.push(id);
    $(e)
      .addClass(id)
      .removeAttr('id');
  });
  $ht = $ht.find('script').length ? replaceIdFromScripts($ht, idReplaced) : $ht;
  return $ht;
}

function replaceIdFromScripts($ht, idToReplace) {
  var ht = $ht.html();
  idToReplace.forEach(function(id) {
    var regex = new RegExp('#' + id, 'gm');
    ht = ht.replace(regex, `.${id}`);
  });
  return $(`<div>${ht}</div>`);
}

function getCoffeeHtml() {
  var $html = getStudioHtml();
  $html.find('script').remove();
  $html.find('[bindable]').each(function(i, e) {
    var field = $(e)
      .attr('field')
      .trim();
    field = field.replace(/ /gm, '_');
    var tag = $(e)[0].tagName;
    if (tag == 'IMG') {
      $(e).attr('src', getRfTag(field));
    } else if (tag == 'INPUT') {
      $(e).attr('val', getRfTag(field));
    } else {
      $(e).text(getRfTag(field));
    }
  });
  var coffeehtml = $html.html();
  if (coffeehtml) {
    return coffeehtml.replace(/&lt;/gm, '<').replace(/&gt;/gm, '>');
  } else {
    return '';
  }
}

function getCoffeeConfig() {
  var $html = getStudioHtml();
  var edit_attr = getEditPropAttr();
  var data_type = getDataTypeAttr($html);
  var event_items = getActionEventItemsAttr($html);
  return edit_attr + data_type + event_items;
}

function getActionEventItemsAttr($html) {
  var event_items =
    `
  ` + `attrs.action_items = {`;
  $html.find('[actionable]').each(function(i, e) {
    var eventName = $(e)
      .attr('eventname')
      .trim()
      .replace(/ /gm, '_');
    var selector = `"[eventname = '${$(e).attr('eventname')}']"`;
    event_items += getActionsAttr(eventName, selector);
  });
  event_items +=
    `
 ` + ` }`;
  return event_items;
}

function getActionsAttr(eventName, selector) {
  return (
    `
` +
    tab +
    tab +
    `${eventName}: {
` +
    tab +
    tab +
    `   "events": ["click"],
` +
    tab +
    tab +
    `   "selector": ${selector},
` +
    tab +
    tab +
    `},`
  );
}

function getActionsJs(selector, eventName) {
  return `
        this.$el.find("${selector}").on('click',function(e){
            if(parentComponent && ["list_repeat"].indexOf(parentComponent.model.field_type) > -1) {
              triggerAction(self.model.field_key_name,'${eventName}','click',e);
            }else{
              e.preventDefault();
              e.stopImmediatePropagation();
              triggerAction(self.model.field_key_name,'${eventName}','click',e);
            }
        });`;
}

function getEditPropAttr() {
  var edithtml = '';
  var $html = $(`<div>${editor.getHtml()}</div>`);
  // creates font editable property.
  $html.find('[font_editable]').each(function(i, e) {
    let name = $(e)
      .attr('font_title')
      .trim();
    let unique = name.replace(/ /gm, '_');
    let defaults = getDefaultStyleForEditProp($(e));
    let fontweight = defaults['font-weight'] || 400;
    let fontsize = defaults['font-size'] || 14;
    let textcolor = defaults['color'] || '#000000';
    let textalign = defaults['text-align'] || 'left';
    edithtml += `
  attrs.${unique}_font_weight = "${fontweight}"
  attrs.${unique}_font_size = "${fontsize}"
  attrs.${unique}_font_size_unit = "px"
  attrs.${unique}_text_color = "${textcolor}"
  attrs.${unique}_text_alignment = "${textalign}"
      `;
  });

  // creates bg editable property
  $html.find('[bg_editable]').each(function(i, e) {
    let name = $(e)
      .attr('bg_title')
      .trim();
    let unique = name.replace(/ /gm, '_');
    let defaults = getDefaultStyleForEditProp($(e));
    let backgroundcolor =
      defaults['background-image'] || defaults['background-color'] || '#ffffff';
    edithtml += `
  attrs.${unique} = "${backgroundcolor}"
    `;
  });

  return edithtml;
}

function getDefaultStyleForEditProp($component) {
  let id = $component.attr('id');
  let classes = $component.attr('class')
    ? $component.attr('class').replace(/ /gm, '.')
    : '';
  let idrule = id ? editor.CssComposer.getRule(`#${id}`) : '';
  let classrule = classes ? editor.CssComposer.getRule(`.${classes}`) : '';
  let style;
  if (idrule) {
    style = idrule.get('style');
  }
  if (classrule) {
    let cssstyle = classrule.get('style');
    style = { ...style, ...cssstyle };
  }
  return style || {};
}

function getDataTypeAttr($html) {
  var formulaflag = false;
  var defaultValue = ``;
  var template =
    `
  ` + `attrs.field_datatypes = [`;
  $html.find('[bindable]').each(function(i, e) {
    var data_source = $(e).attr('bind_from');
    var field = $(e)
      .attr('field')
      .trim();
    field = field.replace(/ /gm, '_');
    defaultValue += getDefaultAttr(field, e);
    if (data_source == 'formula' || data_source == 'both') {
      formulaflag = true;
      var data_type = $(e).attr('data_type');
      var editorFormat = data_type == 'string' ? 'single_line_text' : 'number';
      template += getDataTypeAttrForEachCompositComp(
        field,
        data_type,
        editorFormat
      );
    }
  });

  template += `]`;
  if ($html.find('[bindable]').length > 0) {
    return formulaflag
      ? defaultValue + template.substring(0, template.lastIndexOf(',')) + ']'
      : defaultValue + template;
  } else {
    return template;
  }
}

function getDefaultAttr(field, e) {
  return (
    `
` +
    tab +
    `attrs.${field} = "${getCoffeeAttr(e)}"`
  );
}

function getDataTypeAttrForEachCompositComp(field, data_type, editorFormat) {
  return (
    `
` +
    tab +
    tab +
    tab +
    `field: '${field}'
` +
    tab +
    tab +
    tab +
    `display_name: '${field}'
` +
    tab +
    tab +
    tab +
    `data_type: '${data_type}'
` +
    tab +
    tab +
    tab +
    `field_database_editor_data_format: '${editorFormat}'
` +
    tab +
    `,`
  );
}

function getCoffeeAttr(e) {
  var tag = $(e)[0].tagName;
  var data = '';
  if (tag == 'IMG') {
    data = $(e).attr('src');
  } else {
    data = $(e)
      .text()
      .trim();
  }
  return data;
}

// function getCoffeeCss() {
//   var css = editor.getCss();
//   css = css.replace(/\* { box-sizing: border-box; } body {margin: 0;}/gm, '');
//   css = css.replace(/#/gm, '.');
//   css = css.replace(/([(a-z)(A-Z)-_ .]*{)/gm, '\n.<%= rf.get("cid") %> $& \n');
//   css = css.replace(/} .{{/gm, '}\n.{{').replace(/;/gm, ';\n');
//   return css;
// }

function getCoffeeEdit() {
  // var ht = getStudioHtml();
  var $html = getStudioHtml();
  var edithtml = ``;

  // creates font editable property.
  $html.find('[font_editable]').each(function(i, e) {
    let name = $(e)
      .attr('font_title')
      .trim();
    let unique = name.replace(/ /gm, '_');
    edithtml += `
                <div class="edit_view_ctrl_prop prop_group">
                    <label class="prop_group_label">${name}</label> 
                    <%= Formbuilder.templates['edit/font_size']({
                        "label":  {name:"Size"},
                        "name": "${unique}_font_size",
                        "disableUnit": true
                      }) %>

                    <%= Formbuilder.templates['edit/font_weight']({
                        "label":  {name:"Weight"},
                        "name": "${unique}_font_weight",
                    }) %>
                
                    <%= Formbuilder.templates['edit/color_picker']({
                        "label": {name:"Color", position:"top", width:""},
                        "name": "${unique}_text_color",
                    }) %>

                    <%= Formbuilder.templates['edit/selectbar']({
                        "label": {name:"alingment", position:"top"},
                        "name": "${unique}_text_alignment",
                        "Icon_type":"icon",     
                        "col_width":"three_col",
                    }) %>
                </div>
                `;
  });

  // creates bg editable property
  $html.find('[bg_editable]').each(function(i, e) {
    let name = $(e)
      .attr('bg_title')
      .trim();
    let unique = name.replace(/ /gm, '_');
    edithtml += `<div class="edit_view_ctrl_prop">
                <%= Formbuilder.templates['edit/color_picker']({
                    "label": {name:"${name}", position:"left", width:""},
                    "name": "${unique}",
                    "col_width":"two_col"
                }) %>
                </div>
                `;
  });

  // creates toggle for stikcy property
  if ($html.find('[data-gjs="navbar"]').length) {
    edithtml += `
    <%= Formbuilder.templates['edit/checkbox_boolean']({
      "label": "Sticky",
      "name": "sticky"
    }) %>
    `;
  }

  // creates input edit property
  $html.find('[bindable]').each(function(i, e) {
    var data_source = $(e).attr('bind_from');
    var field = $(e)
      .attr('field')
      .trim();
    var dispaly_name = field;
    field = field.replace(/ /gm, '_');
    if (data_source == 'static' || data_source == 'both') {
      edithtml += `<div class="form-group ui grid flex-center" style="height:auto;min-height:44px;">
                        <label for="" class="six wide column p-l-0 ">${dispaly_name}:</label>
                        <div class="form-control ten wide column">
                            <input type="text" data-rv-value="model.${field}" />
                        </div>
                    </div>
                    `;
    }
  });
  return edithtml;
}

function getRfTag(field) {
  return `<%= rf.get('${field}') %> `;
}

async function getStudioCss(cssfor = 'handlebars') {
  let rawCSS = editor
    .getCss()
    .replace(/\* { box-sizing: border-box; } body {margin: 0;}/gm, '')
    .replace(/#([a-zA-Z])(?=[^}]*{)/g, '.$1');
  rawCSS = processMediaCss(rawCSS);
  let processedResponse = await styleConverter.processCSS(rawCSS, cssfor);
  let processedCSS = '';
  if (processedResponse.success) {
    processedCSS = processedResponse.resp.text;
  }
  processedCSS = processedCSS
    .replace(/} .{{/gm, '}\n.{{')
    .replace(/;(?=[\s]*})/gm, '\n');

  processedCSS += getEditStylePropertyCss(cssfor);
  return processedCSS;
}

async function validateCss() {
  let rawCSS = editor
    .getCss()
    .replace(/\* { box-sizing: border-box; } body {margin: 0;}/gm, '')
    .replace(/#([a-zA-Z])(?=[^}]*{)/g, '.$1');
  rawCSS = processMediaCss(rawCSS);
  let processedResponse = await styleConverter.processCSS(rawCSS, 'handlebars');
  return processedResponse;
}

function processMediaCss(rawCSS) {
  let mediaCss = '';
  let devices = [
    { media: 1024, class: ['.w769-1024', '.w641-768', '.w320-640'] },
    { media: 768, class: ['.w641-768', '.w320-640'] },
    { media: 480, class: '.w320-640' }
  ];
  for (let i = 0; i < devices.length; i++) {
    let regex = new RegExp(
      `@media\\s?\\(max-width:\\s?${devices[i].media}px\\s?\\).*?}}`,
      'gm'
    );
    let match = regex.exec(rawCSS);
    if (match != null && match.length) {
      let mediastr = match[0];
      mediastr = mediastr.replace(
        new RegExp(
          `@media\\s?\\(max-width:\\s?${devices[i].media}px\\s?\\)`,
          'gm'
        ),
        devices[i].class
      );
      mediaCss += mediastr;
    }
  }
  rawCSS = rawCSS.replace(/@media/gm, '@media print,screen and');
  return rawCSS + mediaCss;
}

function getEditStylePropertyCss(cssfor) {
  let css = '';
  let $html = getStudioHtml();
  if (cssfor == 'coffee') {
    var sel = `.<%= rf.get('cid') %> .`;
    var prefix = `<%= rf.get('`;
    var suffix = `') %>`;
  } else {
    var sel = `.{{sid}} .`;
    var prefix = `{{`;
    var suffix = `}}`;
  }
  $html.find('[font_editable]').each(function(i, e) {
    let name = $(e)
      .attr('font_title')
      .trim();
    let unique = name.replace(/ /gm, '_');
    let className = $(e)
      .attr('class')
      .trim()
      .replace(/ /gm, '.');
    css += `${sel + className}{
    font-weight : ${prefix}${unique}_font_weight${suffix};
    font-size: ${prefix}${unique}_font_size${suffix}${prefix}${unique}_font_size_unit${suffix};
    color : ${prefix}${unique}_text_color${suffix};
    text-align :${prefix}${unique}_text_alignment${suffix};
  }
    `;
  });

  // creates bg editable property
  $html.find('[bg_editable]').each(function(i, e) {
    let name = $(e)
      .attr('bg_title')
      .trim();
    let unique = name.replace(/ /gm, '_');
    let className = $(e)
      .attr('class')
      .trim()
      .replace(/ /gm, '.');
    css += `${sel + className}{
    background-color : ${prefix}${unique}${suffix};
    background-image : ${prefix}${unique}${suffix};
  }
    `;
  });

  // creates sticky css for menu bar
  if ($html.find('[data-gjs="navbar"]').length && cssfor == 'handlebars') {
    css += `
    .{{sid}}.sticky{
      position: sticky !important;
      top: 0;
      z-index: 9;
    }
    .{{sid}} .component-head-container{
      margin:0px;
    }
    `;
  }

  return css;
}

function getSetValueAndGetValueCode() {
  // var ht = getStudioHtml();
  var $html = getStudioHtml();
  var output = [];
  var setcode = ``;
  var getcode = ``;
  $html.find('[bindable]').each(function(i, e) {
    var data_source = $(e).attr('bind_from');
    var field = $(e)
      .attr('field')
      .trim();
    field = field.replace(/ /gm, '_');
    var target = $(e)
      .attr('class')
      .replace(/ /gm, '.');
    var tagType = $(e)[0].tagName;
    if (data_source == 'formula' || data_source == 'both') {
      setcode += getIfConBasedOnFieldType(field, target, tagType);
      getcode += createObjectForGetValue(field, target, tagType);
    }
  });
  output.push(setcode);
  output.push(getcode);
  return output; //// at 0 index it stores setvalue code and at 1 indx it stores getValue code
}
function getCoffeeScript() {
  var $html = getStudioHtml();
  var setcode = ``;
  $html.find('[bindable]').each(function(i, e) {
    var data_source = $(e).attr('bind_from');
    var field = $(e)
      .attr('field')
      .trim();
    field = field.replace(/ /gm, '_');
    var target = $(e)
      .attr('class')
      .replace(/ /gm, '.');
    var tagType = $(e)[0].tagName;
    if (data_source == 'formula' || data_source == 'both') {
      setcode += getIfConBasedOnFieldTypeForCoffee(field, target, tagType);
    }
  });
  return `(function (obj) {
        if (!_.isEmpty(obj)) {
          var objectkeys = Object.keys(obj);
          ${setcode}
        }
    })(<%= JSON.stringify(rf.get("LiveData") || {}) %>)`;
}

function getActionEventListner() {
  var $html = getStudioHtml();
  var event_items = '';
  /// for action event
  $html.find('[actionable]').each(function(i, e) {
    var eventName = $(e)
      .attr('eventname')
      .trim()
      .replace(/ /gm, '_');
    var selector = `[eventname = '${$(e).attr('eventname')}']`;
    event_items += getActionsJs(selector, eventName);
  });

  /// for component script actions
  $html.find('script').each(function(i, e) {
    event_items +=
      `
    ` +
      $(e).html() +
      `
    `;
  });
  return event_items;
}

function getIfConBasedOnFieldTypeForCoffee(field, target, tagType) {
  if (tagType == 'IMG') {
    return `if (objectkeys.indexOf('${field}') > -1) {
      obj.${field} = _.unescape(obj.${field});
      $(".<%= rf.get("cid") %>").find('.${target}').attr('src', obj.${field});
    }
    `;
  } else if (tagType == 'INPUT') {
    return `if (objectkeys.indexOf('${field}') > -1) {
      obj.${field} = _.unescape(obj.${field});
      $(".<%= rf.get("cid") %>").find('.${target}').val(obj.${field});
    }
    `;
  } else {
    return `if (objectkeys.indexOf('${field}') > -1) {
      obj.${field} = _.unescape(obj.${field});
      $(".<%= rf.get("cid") %>").find('.${target}').text(obj.${field});
    }
    `;
  }
}

function getIfConBasedOnFieldType(field, target, tagType) {
  if (tagType == 'IMG') {
    return `if (objectkeys.indexOf('${field}') > -1) {
      obj.${field} = _.unescape(obj.${field});
      self.$el.find('.${target}').attr('src', obj.${field});
      self.initConditionalVisibility(self.model.field_key_name + '.${field}');
    }
    `;
  } else if (tagType == 'INPUT') {
    return `if (objectkeys.indexOf('${field}') > -1) {
      obj.${field} = _.unescape(obj.${field});
      self.$el.find('.${target}').val(obj.${field});
      self.initConditionalVisibility(self.model.field_key_name + '.${field}');
    }
    `;
  } else {
    return `if (objectkeys.indexOf('${field}') > -1) {
      obj.${field} = _.unescape(obj.${field});
      self.$el.find('.${target}').text(obj.${field});
      self.initConditionalVisibility(self.model.field_key_name + '.${field}');
    }
    `;
  }
}
function createObjectForGetValue(field, target, tagType) {
  if (tagType == 'IMG') {
    return `${field} : this.$el.find('.${target}').attr('src') || "",
    `;
  } else if (tagType == 'INPUT') {
    return `${field} : this.$el.find('.${target}').val() || "",
    `;
  } else {
    return `${field} : this.$el.find('.${target}').text() || "",
    `;
  }
}

function getStudioJs(control_name) {
  var getset = getSetValueAndGetValueCode();
  var setValue = getset[0];
  var getValue = getset[1];
  var actionEventListner = getActionEventListner();
  return `
BSCOMPONENTS["${control_name}"] = function() {
    this.default = {
        customVariable: ""
    };
    this._templateChanges ={};
    this._dhqSelected = false;
    this.statesBlockMapObj = {};
    this.initComponent = function () {
        var self = this;
        var parentComponent = Components[this.model.parent_id];
        self.createStateBlockMapObj();
        /* IF THIS IS CHID OF SOME LIST RepeAT THEN INITILIZE SELECTION EVENT ELSE DON'T DO ANYTHING */
        if(parentComponent) {
           var itemSelectionFun = parentComponent["onItemSelection"];
            self.$el.find('.wrapper').on('click', function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if(itemSelectionFun) {
                    itemSelectionFun.call(parentComponent, self.model.field_key_name)
                }
            }); 
        } 

        ${actionEventListner}
    };
    this.createStateBlockMapObj = function(){
        let states = this.model.statesObj;
        for(key in states){
            blockSelector = states[key].selected && states[key].selected.selector
            this.statesBlockMapObj[blockSelector] = this.$el.find("."+blockSelector);
        }
        // for selected states that are for wrapper.
        this.statesBlockMapObj["wrapper"] = this.$el.find(".wrapper");
    }
    this.setState = function (stateName, target = "wrapper") {
        this.statesBlockMapObj[target] && this.statesBlockMapObj[target].addClass(stateName);
    };
    this.removeState = function (stateName, target = "wrapper") {
        this.statesBlockMapObj[target] && this.statesBlockMapObj[target].removeClass(stateName);
    };
    this.beforeSubmitValidation = function (obj) {
        //Control validation will be done here.
        return true;
    };
    this.setValue = function (obj) {
      var self = this;
      if(!_.isEmpty(obj)){
        var objectkeys = Object.keys(obj);
        ${setValue}
      }else{

      }
    };
    this.reset = function (obj) {
        //Reset your control here.
    };
    this.getValue = function (forSubmit) {
        var response = {
        ${getValue}
        };
        return { 'question': this.model.label, 'value': JSON.stringify(response), id: this.model.field_key_name, name: this.model.field_display_key_name };
    };
};
BSCOMPONENTS["${control_name}"].prototype = BaseComponent;
`;
}

function getStudioHandleBar(control_name) {
  var ht = getCoffeeHtml();
  var output = ht.replace(/<%= rf.get\(/gm, '{{').replace(/\) %>/gm, '}}');
  return `<script id="ctrl-template-${control_name}" type="text/x-handlebars-template">
    <div class="fb-field-wrapper response-field-{{field_type}} {{cid}} {{sid}} {{#if hidden}}hide{{/if}} {{#if sticky}}sticky{{/if}}{{#if field_fullview}} fb-fullview-field {{/if}} {{#if field_responsive}}fb-responsive-field{{/if}} {{#if disabled}}isDisabled{{/if}}" data-control="text" data-requiredfield="{{required}}" style="position:relative">
        <div class="component-loader hide {{#if disabled}}{{else}} isLoaderWhite{{/if}} ">
            <i class=" notched circle loading icon"></i>
        </div>
        <div class="component-head-container {{#if label}}{{else}}{{#if required}}{{else}}hide{{/if}}{{/if}}">
            <span>{{#if label_hidden}}{{else}}{{label}}{{/if}}
                {{#if required}}
                    <span class="requiredAstrick">*</span>
                {{/if}}
            </span>
        </div>
        <div class="wrapper {{#if disabled}}isDisabled{{/if}}">
            ${output}
        </div>
        <div class="fb-field-error-message"></div>
    </div>

    </script>`;
}

function getCoffee(control_name, display_name) {
  return new Promise(async function(resolve, reject) {
    var viewHtml = getCoffeeHtml();
    var script = getCoffeeScript();
    var style = await getStudioCss('coffee');
    var edit = getCoffeeEdit();
    var data_type = getCoffeeConfig();
    var statesObj = StateManager.stateJson(editor);
    resolve(`
Formbuilder.registerField '${control_name}',
group: 'new'
order: 1
type: 'non_input'
view: """
  <div class="fb-field-wrapper control-body-style response-field-<%= rf.get('field_type') %> <%= rf.get('cid') %>" data - requiredfield="<%= rf.get('required') %>" >
    <div class="wrapper">
      <!-- Your code goes here-->
      ${viewHtml}
      <!-- Your code ends here-->
    </div>
    <div class="fb-field-error-message">
      <!-- Error Message Here -->
    </div>
  </div >

  <style>
    ${style}
  </style>

  <script>
    ${script}
  </script>
"""

edit: """
  <div class="category-section" >
    <div class="ui accordion edit-accordion">
      <div class="title active header-accordion">
        Properties <span class="caret"></span>
      </div>
      <div class="content active">
        <div class="accordion-content-inner">
          <!-- your code here -->
            ${edit}
          <!-- your code ends here-->
        </div>
      </div>
    </div>
  </div >
  """
manual_data: """

"""
addButton: """
  <span class="symbol" >
    <span class="symbol-icon-box">
      <img src="app/src/images/Icons-Controls-Jet-black/Default-Icon.png" />
    </span>
    <span class="clabel">Quantity</span>
  </span >
"""

defaultAttributes: (attrs) ->
  attrs.label = '${display_name}'
  attrs.label_hidden = true
  attrs.statesObj = ${JSON.stringify(statesObj)}
  attrs.field_responsive = false
  attrs.sticky = false
  attrs.dhq_config = {
    strict_update: ["field_datatypes","action_items","statesObj"]
  }
  attrs.data_type = ""
  attrs.field_composition_type = "composite"
  attrs.field_available_in_database_editor = false
  attrs.field_editable_in_database_editor = false
  attrs.field_values_source = ""
  attrs.field_database_editor_data_format = ""
  attrs.field_client_side_get_data_enabled = true
  ${data_type}
  attrs
            `);
  });
}

export default {
  getCoffee: getCoffee,
  getCss: getStudioCss,
  getJs: getStudioJs,
  getHB: getStudioHandleBar,
  validateCss: validateCss
};
